import * as React from 'react';
var AnchorContext = /*#__PURE__*/React.createContext(null);
export default AnchorContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/anchor/context.js
// module id = 224
// module chunks = 0